export default function useUrls() {
  const socketUrl = process.env.REACT_APP_API_URL;
  const apiUrl = socketUrl + "/api";
  return { apiUrl, socketUrl };
}
